<!----- 专家出库申请审核列表 ---->
<template>
  <page-view title="出库审核列表">
    <a-card class="mb-3">
      <a-form-model :model="outApplyForForm"
                    class="exi_form v2"
                    ref="form"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="专家名称"
                           prop="expertName">
          <a-input v-model="outApplyForForm.expertName"
                   placeholder="专家名称" />
        </a-form-model-item>
        <a-form-model-item label="申请时间"
                           prop="applyForDate">
          <a-range-picker v-model="applyForDate"
                          :disabled-date="disabledDate"
                          @change="applyForDateChange"
                          style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="审核状态"
                           prop="applyForDate">
          <dict-cascader dictKey="ExpertOutApplyForAuditStatus"
                         v-model="outApplyForForm.auditStatus"
                         style="width: 100%" />
        </a-form-model-item>
        <a-button type="primary"
                  @click="onSearch()">查询
        </a-button>
        <a-button @click="reset()">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table ref="outApplyForTable"
               :columns="columns"
               :data="outApplyForList"
               :rowKey="record => record.id"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }">
        <template slot="expertName"
                  slot-scope="record">
          <a @click.stop="onViewModal(record)">{{ record.extras.expertName }}</a>
        </template>
        <template slot="applyForDate"
                  slot-scope="record">
          {{record.applyForDate | dateFormat}}
        </template>
        <template slot="auditDate"
                  slot-scope="record">
          <span v-if="record.auditDate"> {{record.applyForDate | dateFormat}}</span>
          <span v-else>/</span>
        </template>
        <template slot="auditStatus"
                  slot-scope="record">
          <a-tag color="blue"
                 v-if="record.auditStatus==2">待审核</a-tag>
          <a-tag color="green"
                 v-if="record.auditStatus==0">废弃</a-tag>
          <a-tag color="red"
                 v-if="record.auditStatus==1">同意</a-tag>
        </template>
        <template slot="action"
                  slot-scope="record">
          <a-space v-if="record.auditStatus==2">
            <a-button type="danger"
                      @click="onAggree(record)">同意出库</a-button>
            <a-button type="primary"
                      @click="onDisagree(record)">废弃</a-button>
          </a-space>
          <span v-else>/</span>
        </template>
      </s-table>
    </a-card>
    <expert-view-modal ref="expertView"
                       :visible="expertViewVisible"
                       :fromType="ExpertFromType.STOCK_IN"
                       @cancel="()=>expertViewVisible = false" />
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import DictCascader from '@/components/dict/DictCascader'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { GetOutApplyForAll, AuditExpertOutApplyFor } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'

export default {
  name: 'ExpertOutApplyForAudit',
  components: {
    PageView,
    STable,
    expertViewModal,
    DictCascader
  },
  data () {
    return {
      expertViewVisible: false,
      outApplyForForm: { auditStatus: '2' },
      applyForDate: null,
      columns: [{ title: '专家姓名', width: '120px', scopedSlots: { customRender: 'expertName' } },
      { title: "申请日期", align: 'center', width: '150px', scopedSlots: { customRender: 'applyForDate' } },
      { title: "出库原因", dataIndex: "outReason" },
      { title: "审核日期", align: 'center', width: '150px', scopedSlots: { customRender: 'auditDate' } },
      { title: "审核状态", align: 'center', width: '120px', scopedSlots: { customRender: 'auditStatus' } },
      { title: '操作', align: 'center', width: '250px', scopedSlots: { customRender: 'action' } }
      ],
      outApplyForList: async (parameter) => {
        const data = { ...parameter, ...this.outApplyForForm }
        return GetOutApplyForAll(data)
      },
    }
  },
  computed: {
    ExpertFromType () {
      return ExpertFromType
    }
  },
  methods: {
    onSearch () {
      this.$refs.outApplyForTable.refresh(true)
    },
    reset () {
      this.applyForDate = null
      this.outApplyForForm = { auditStatus: '2' }
      this.onSearch()
    },
    applyForDateChange (date, dateString) {
      this.outApplyForForm.applyForStartDate = dateString[0]
      this.outApplyForForm.applyForEndDate = dateString[1]
    },
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },
    //打开窗口查看信息
    onViewModal (record) {
      this.expertViewVisible = true
      this.$refs.expertView.loadData(record.expertId)
    },
    onAggree (record) {
      const data = { ...record }
      const that = this
      this.$confirm({
        title: `确定同意${data.extras.expertName}专家出库申请?`,
        onOk () {
          data.auditStatus = 1
          that.handleExpertOut(data)
        },
      })
    },
    onDisagree (record) {
      const data = { ...record }
      const that = this
      this.$confirm({
        title: `确定废弃${data.extras.expertName}专家出库申请?`,
        onOk () {
          data.auditStatus = 0
          that.handleExpertOut(data)
        },
      })
    },
    async handleExpertOut (data) {
      const res = await AuditExpertOutApplyFor(data)
      if (res.code == 200) {
        this.$message.success('操作成功')
        this.$refs.outApplyForTable.refresh(true)
      }
    }
  },
}
</script>

<style lang="less" scoped>
</style>